/* ============================================================
   BDG Mobile Menu — acordeón (listener delegado en document para
   funcionar sobre el drawer que el tema inyecta dinámicamente).
   ============================================================ */
(function () {
  'use strict';

  function panelOf(head) {
    var id = head.getAttribute('aria-controls');
    return id ? document.getElementById(id) : null;
  }
  function setHeight(panel) {
    panel.style.maxHeight = panel.scrollHeight + 'px';
  }

  document.addEventListener('click', function (e) {
    var head = e.target.closest ? e.target.closest('.bdg-macc__head') : null;
    if (!head) return;
    e.preventDefault();
    var panel = panelOf(head);
    if (!panel) return;

    var isOpen = head.getAttribute('aria-expanded') === 'true';
    var root = head.closest('.navigation__tier-1') || document;

    // single-open: cerrar hermanos abiertos
    root.querySelectorAll('.bdg-macc__head[aria-expanded="true"]').forEach(function (h) {
      if (h === head) return;
      h.setAttribute('aria-expanded', 'false');
      var p = panelOf(h);
      if (p) p.style.maxHeight = null;
    });

    if (isOpen) {
      head.setAttribute('aria-expanded', 'false');
      panel.style.maxHeight = null;
    } else {
      head.setAttribute('aria-expanded', 'true');
      setHeight(panel);
    }
  }, false);

  // recalcular altura cuando una imagen termina de cargar dentro de un panel abierto
  document.addEventListener('load', function (e) {
    var img = e.target;
    if (!img || img.tagName !== 'IMG' || !img.closest) return;
    var panel = img.closest('.bdg-macc__panel');
    if (panel && panel.style.maxHeight && panel.style.maxHeight !== '0px') {
      setHeight(panel);
    }
  }, true);
})();
